export default () => {
    const videosWrapper = document.querySelectorAll('.video-wrapper');

    if(!videosWrapper) {
        return;
    }

    const videoToggle = (button, video) => {
        if(button.classList.contains('video-controllers--playing')) {
            video.pause();
            button.classList.remove('video-controllers--playing');
            return;
        }

        button.classList.add('video-controllers--playing');
        video.play();
    }

    const videoControllerHandler = (controller) => {
        if(!controller) {
            return;
        }

        const video = controller.closest('.video-wrapper').querySelector('video');
        videoToggle(controller, video)
    }

    document.addEventListener('click', (e) => {
        videoControllerHandler(e.target.closest('.video-wrapper'))
    });
}
